import { useEffect } from 'react'

/**
 * Hook to lock/unlock body scroll
 * Prevents page scrolling when loading screens are visible
 *
 * @param {boolean} locked - Whether to lock body scroll (default: true)
 */
export const useBodyScrollLock = (locked = true) => {
  useEffect(() => {
    if (locked) {
      document.body.style.overflow = 'hidden'
      return () => {
        document.body.style.overflow = ''
      }
    }
  }, [locked])
}

export default useBodyScrollLock
